import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

// we can't use mat-tooltip because we need to inject html in some cases, which mat-tooltip doesn't support
@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective {

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
  ) {}

  @Input() message: string;
  @Input() direction: 'right' | 'left' = 'left'; // we also can predefine left or right direction with input
  // we are using this on emergency contact page;
  private node: any;

  @HostListener('touchstart')
  touchstart(): void {
    if (!this.node) {
      this.addTooltip();
    }
  }

  @HostListener('touchend')
  touchend(): void {
    this.deleteTooltip();
  }

  @HostListener('mouseenter')
  mouseenter(): void {
    if (!this.node) {
      this.addTooltip();
    }
  }

  @HostListener('mouseleave')
  mouseleave(): void {
    this.deleteTooltip();
  }

  // we need to make tooltip always visible, no matter where user hover / touch it
  public addTooltip(): void {
    if (!this.message) return;
    const elementRect = this.elementRef.nativeElement.getBoundingClientRect();
    const tooltipNode = this.renderer.createElement('span');
    this.renderer.setAttribute(tooltipNode, 'id', 'custom-tooltip');
    this.node = tooltipNode;
    tooltipNode.innerHTML = this.message;
    this.renderer.appendChild(this.elementRef.nativeElement, tooltipNode);
    const dimensions = tooltipNode.getBoundingClientRect();
    // we need to know actual dimensions of out tooltip to calculate it position, so we need to:
    // 1) insert it
    // 2) measure it
    // 3) delete it ==> to prevent DOM blinking :(
    // 4) insert it again but that time calculate it position based on actual width / height
    this.renderer.removeChild(this.elementRef.nativeElement, tooltipNode);
    const windowWidth = window.innerWidth;
    const relativePosition = this.direction === 'left' ? elementRect.x : 0;
    if (relativePosition + elementRect.width + dimensions.width + 10 > windowWidth) {
      const offset = (windowWidth - 300) / 2;
      const verticalDirection = window.innerHeight - elementRect.y > 0 + elementRect.y ? 'top' : 'bottom';
      this.renderer.setStyle(tooltipNode, verticalDirection, (elementRect.height + 5) + 'px');
      this.renderer.setStyle(tooltipNode, this.direction, (elementRect.x + elementRect.width - offset - dimensions.width) + 'px');
    } else {
      this.renderer.setStyle(tooltipNode, 'top', (elementRect.height / 2 - dimensions.height / 2) + 'px');
      this.renderer.setStyle(tooltipNode, this.direction, (elementRect.width / 2 + 15) + 'px');
    }
    this.renderer.appendChild(this.elementRef.nativeElement, tooltipNode);
  }

  public deleteTooltip(): void {
    if (this.node) {
      this.renderer.removeChild(this.elementRef.nativeElement, this.node);
      this.node = null;
    }
  }

}
